module.exports = __webpack_public_path__ + "static/media/thief_boy-hiding.23b0f551.svg";